module.exports = __webpack_public_path__ + "static/media/retouched-evening-photo-product.be6adb88.jpg";